/*
 * What to put in the Authorization header, given what the API just handed us.
 *
 * There are two shapes, and the panel only ever knew about one of them.
 *
 * An admin or a school is given Sanctum's own token: the row's id, a pipe, and
 * forty random characters. The panel keeps the half after the pipe.
 *
 * Anybody above a school - a driver, a parent, a guardian - is given that same
 * token encrypted (AuthController::loginViaToken, `if ($user->role_id > 2)`).
 * It arrives as one long hex string with no pipe anywhere in it, and the
 * middleware turns it back into the real token on the way in. It has to be
 * sent whole.
 *
 * Splitting that on "|" and keeping the second half gives undefined. Stored,
 * that becomes the string "undefined" - which is not null, so the panel
 * believed the family was signed in, drew the portal, and then had every
 * request refused as "Bearer undefined". A second of their children, and back
 * to the login screen. Exactly what a parent saw and an admin never did.
 *
 * Kept in a file of its own, with nothing imported, because the sign-in around
 * it is Firebase all the way down and this is the part worth testing.
 */
export function panelToken(apiToken) {
  if (apiToken === null || apiToken === undefined) {
    return null
  }

  const token = String(apiToken)

  //no pipe: an encrypted token, which means all of it or none of it
  if (token.indexOf("|") === -1) {
    return token
  }

  return token.split("|")[1]
}

export default panelToken
